import React, { useState, useEffect } from 'react';

export default function CaptchaComponent({ onCaptchaComplete }) {
  const [num1, setNum1] = useState(0);
  const [num2, setNum2] = useState(0);
  const [userAnswer, setUserAnswer] = useState('');
  const [isCorrect, setIsCorrect] = useState(null);

  const generateCaptcha = () => {
    const n1 = Math.floor(Math.random() * 10) + 1;
    const n2 = Math.floor(Math.random() * 10) + 1;
    setNum1(n1);
    setNum2(n2);
    setUserAnswer('');
    setIsCorrect(null);
  };

  useEffect(() => {
    generateCaptcha();
  }, []);

  const handleAnswerChange = (e) => {
    const answer = e.target.value;
    setUserAnswer(answer);
    
    const correctAnswer = num1 + num2;
    const isAnswerCorrect = parseInt(answer) === correctAnswer;
    setIsCorrect(isAnswerCorrect);
    
    // Notify parent component about captcha status
    onCaptchaComplete(isAnswerCorrect);
  };

  const handleRefresh = () => {
    generateCaptcha();
    onCaptchaComplete(false);
  };

  return (
    <div className="mb-6">
      <label className="block text-sm font-semibold text-gray-700 mb-3">
        <div className="flex items-center">
          <svg className="w-4 h-4 mr-2 text-gray-500" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m5.618-4.016A11.955 11.955 0 0112 2.944a11.955 11.955 0 01-8.618 3.04A12.02 12.02 0 003 9c0 5.591 3.824 10.29 9 11.622 5.176-1.332 9-6.03 9-11.622 0-1.042-.133-2.052-.382-3.016z" />
          </svg>
          Security Check
        </div>
      </label>
      <div className="flex items-center gap-3">
        <div className="flex items-center gap-3 bg-gradient-to-r from-gray-50 to-gray-100 px-4 py-3 rounded-xl border border-gray-200 flex-1">
          <span className="text-xl font-mono text-gray-700 bg-white px-3 py-1 rounded-lg shadow-sm">{num1}</span>
          <span className="text-xl font-semibold text-gray-600">+</span>
          <span className="text-xl font-mono text-gray-700 bg-white px-3 py-1 rounded-lg shadow-sm">{num2}</span>
          <span className="text-xl font-semibold text-gray-600">=</span>
          <input
            type="number"
            value={userAnswer}
            onChange={handleAnswerChange}
            className="w-20 text-center border-none bg-white text-xl font-mono focus:outline-none focus:ring-2 focus:ring-indigo-500 rounded-lg px-3 py-1 shadow-sm"
            placeholder="?"
            required
          />
        </div>
        <button
          type="button"
          onClick={handleRefresh}
          className="p-2 text-gray-500 hover:text-indigo-600 hover:bg-indigo-50 rounded-lg transition-all duration-200"
          title="Refresh captcha"
        >
          <svg className="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 4v5h.582m15.356 2A8.001 8.001 0 004.582 9m0 0H9m11 11v-5h-.581m0 0a8.003 8.003 0 01-15.357-2m15.357 2H15" />
          </svg>
        </button>
      </div>
      {isCorrect === false && userAnswer !== '' && (
        <div className="mt-2 p-3 bg-red-50 border border-red-200 rounded-lg">
          <div className="flex items-center text-sm text-red-700">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            Incorrect answer. Please try again.
          </div>
        </div>
      )}
      {isCorrect === true && (
        <div className="mt-2 p-3 bg-green-50 border border-green-200 rounded-lg">
          <div className="flex items-center text-sm text-green-700">
            <svg className="w-4 h-4 mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" />
            </svg>
            ✓ Correct! You can proceed.
          </div>
        </div>
      )}
    </div>
  );
} 